<p class="helppoint-title">{{data.title}}</p>
<textarea-component class="col-x" [(ngModel)]="event"
    placeholder="{{'ECMR.EVENTS.ADD.PLACEHOLDER' | translate}}" [rows]="3">
</textarea-component>
<div align="end">
    <button mat-raised-button class="helppoint-button confirm" (click)="onConfirm()" [disabled]="!pendingSave"
        color="primary">{{'MAINTENANCE.ACCEPT' | translate}}</button>
    <button mat-raised-button class="helppoint-button close" (click)="onClose()"
        color="link">{{'CANCEL.BUTTON' | translate}}</button>
</div>
